import { businessHolidaySchema, type LocalDay } from '@noconflict/contracts';
import type { Supabase } from '../../shared/api/supabase';

/** The days that are not business days, as `YYYY-MM-DD`, oldest first: what `computeDueAt` takes. */
export async function listHolidays(client: Supabase): Promise<LocalDay[]> {
  const { data, error } = await client.from('business_holidays').select('day, name').order('day');
  if (error) throw new Error(error.message);
  return businessHolidaySchema
    .array()
    .parse(data)
    .map((h) => h.day);
}
